
import { defineComponent, PropType } from 'vue';
import { QuestionAnswerState } from '@/vuex/AnswerStore';
import { GqlAllMyReports } from '@/gql/AllMyReports';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FilePreview from '@/components/FilePreview.vue';
import InspectFile from '@/components/Forms/QuestionType/File.vue';

export default defineComponent({
  props: {
    value: { type: Object },
    qa: { type: Object as PropType<QuestionAnswerState> },
    report: { type: Object as PropType<GqlAllMyReports> },
  },
  components: {
    FontAwesomeIcon,
    FilePreview,
    InspectFile,
  },
  methods: {
    updateValue(e) {
      this.$emit('updateValue', [e[0], e[1]]);
    },
  },
});
